export const CONVERT_AI_MODAL_STORAGE_KEY = "convertDocumentAiModalState";

interface ConvertAiModalPersistedFile {
    name: string;
    size: number;
}

export interface ConvertAiModalPersistedState {
    files: ConvertAiModalPersistedFile[];
    isProcessing: boolean;
}

const getStorage = (): Storage | null => {
    if (typeof window === "undefined") {
        return null;
    }
    return window.localStorage;
};

export const readConvertAiModalState = (): ConvertAiModalPersistedState | null => {
    const storage = getStorage();
    if (!storage) {
        return null;
    }
    try {
        const raw = storage.getItem(CONVERT_AI_MODAL_STORAGE_KEY);
        if (!raw) {
            return null;
        }
        return JSON.parse(raw) as ConvertAiModalPersistedState;
    } catch {
        return null;
    }
};

export const saveConvertAiModalState = (state: ConvertAiModalPersistedState): void => {
    const storage = getStorage();
    if (!storage) {
        return;
    }
    try {
        storage.setItem(CONVERT_AI_MODAL_STORAGE_KEY, JSON.stringify(state));
    } catch {
        // ignore storage quota issues
    }
};

export const clearConvertAiModalState = (): void => {
    const storage = getStorage();
    if (!storage) {
        return;
    }
    storage.removeItem(CONVERT_AI_MODAL_STORAGE_KEY);
};



